import myzxios from '../utils/myaxios'

export function getRoleAll(data){
    return myzxios({
        url: '/manager/getAllRole',
        data,
        method: 'post'
    })
}

export function getRole(data) {
    return myzxios({
        url: '/manager/getRole',
        params: data
    })
}

export function addRole(data) {
    return myzxios({
        url: '/manager/addRole',
        data,
        method: 'POST'
    })
}